document.addEventListener('DOMContentLoaded', function() {
  var menuItems = document.querySelectorAll('[js-mob-menu-item]');
  
  // Activate first tab by default
  if (menuItems.length > 0) {
    menuItems[0].classList.add('active');
  }
  
  menuItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      var childMenu = this.querySelector('[js-mob-child-menu]');
      
      if (childMenu) {
        e.preventDefault();
        e.stopPropagation();
        
        menuItems.forEach(function(mi) {
          mi.classList.remove('active');
        });
        
        this.classList.add('active');
      }
    });
  });
  
  var productLinks = document.querySelectorAll('.mob-child-menu-link');
  productLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
});